import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

class StaffCertificationsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      id: null,
      staff_id: null,
      certification_id: null,
      certification_supplier_id: null,
      date_start: null,
      date_finish: null,
      result: null,
      pf: null,
      expire: null,
      expire_fixed: null,
      type: 0,
      emissao: null,
      new_designation: 0,
      states: [],
      certifications_list: [],
      certification_suppliers_list: [],
      simple_list: [
        {value: 1, label: "Sim"},
        {value: 0, label: "Não"},
      ],
     };
    //Handlers
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleAlert = this.handleAlert.bind(this);

    this.loadData = this.loadData.bind(this);
    this.refreshSupplierSelect = this.refreshSupplierSelect.bind(this);
    this.edit = this.edit.bind(this);
    this.checkChangeExpiration = this.checkChangeExpiration.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChangeCertification(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, this.clearSupplierList());
    } else {
      change[name] = event.value;
      this.setState(change, this.refreshSupplierSelect(event.value));
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  clearSupplierList (name, event) {
    this.setState({ certification_suppliers_list: [] });
  } 
  
  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/colaborador/certificado/info/edicao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            staff_id: responseJson.data.main.staff_id,
            certification_id: responseJson.data.main.certification_id,
            certification_supplier_id: responseJson.data.main.certification_supplier_id,
            date_start: responseJson.data.main.date_start_str,
            date_finish: responseJson.data.main.date_finish_str,
            result: responseJson.data.main.result,
            pf: responseJson.data.main.pf_total,
            expire: responseJson.data.main.expire_str,
            expire_fixed: responseJson.data.main.expire_str,
            type: responseJson.data.main.type,
            emissao: responseJson.data.main.emissao_str,
            certifications_list: responseJson.data.certifications_list,
            certification_suppliers_list: responseJson.data.certification_suppliers_list,
         });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });
    });
  }

  
  checkChangeExpiration(event) {
    event.preventDefault();
    if (this.state.expire !== this.state.expire_fixed) {
      this.setState({ modal: true });
    } else {
      this.edit(0);
    }
  }

  edit(event) {
    this.setState({ modal: false }) 
    var datasave = {
      id: this.state.id,
      staff_id: this.state.staff_id,
      certification_id: this.state.certification_id,
      certification_supplier_id: this.state.certification_supplier_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      result: this.state.result,
      pf: this.state.pf,
      expire: this.state.expire,
      type: this.state.type,
      emissao: this.state.emissao,
      new_designation: event,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/certificado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshSupplierSelect (event) {
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/fornecedores/lista/' + event, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({certification_suppliers_list: responseJson.data});
        }
        if(typeof event.message !== 'undefined') {
          self.handleAlert(event.message, event.status, 'open');
        } else {
          self.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar certificado</h3>
      <Link to={"/colaborador/" + self.props.match.params.staff_id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.checkChangeExpiration}> 
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Certificado:</label>
            <Select
              className="form-field-name"
              name="certification_id"
              value={this.state.certification_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChangeCertification.bind(this, 'certification_id')}
              options={this.state.certifications_list}
            />    
          </div>
          <div className="col-md-6 form-group">
            <label>Data de início:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Local:</label>
            <Select
              className="form-field-name"
              name="certification_supplier_id"
              value={this.state.certification_supplier_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'certification_supplier_id')}
              options={this.state.certification_suppliers_list}
            />    
          </div>
          <div className="col-md-6 form-group">
            <label>Data de término:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nota:</label>
            <input type="text" className="form-control" name="result" value={this.state.result} onChange={this.handleChange.bind(this, 'result')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Carga horária (em minutos)</label>
            <input type="text" className="form-control" name="pf" value={this.state.pf} onChange={this.handleChange.bind(this, 'pf')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Data de expiração:</label>
            <InputMask value={this.state.expire}  maskChar={null} name="expire" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder="" />
          </div>
          <div className="col-md-6 form-group">
            <label>Ministrou o curso?</label>
            <Select
              className="form-field-name"
              name="type"
              value={this.state.type}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'type')}
              options={this.state.simple_list}
            />    
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Data de emissão:</label>
            <InputMask value={this.state.emissao}  maskChar={null} name="emissao" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'emissao')} placeholder="" />
          </div>
        </div>
        <div className="row">
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar certificação</button>
      </form>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">A  data de expiração, ou a instrução, foram alterados, deseja cadastrar uma nova designação com a nova mudança?</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-default btn-lg btn-block" onClick={()=>this.setState({ modal: false })}>Cancelar</button>
        </div>
        <div className="col-md-4">
          <button className="btn btn-danger btn-lg btn-block" onClick={()=>this.edit(0)}>Não</button>
        </div>
        <div className="col-md-4">
          <button className="btn btn-success btn-lg btn-block" onClick={()=>this.edit(1)}>Sim</button>
        </div>
      </div>
    
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffCertificationsEdit;



// WEBPACK FOOTER //
// ./src/Components/StaffCertifications/StaffCertificationsEdit.js